<template>
  <div style="top: 0px; height: 50px; width: 100%; background-color: blue; color: #fff;">
    <header class="main-header">
      <a href="#" class="logo" style="padding: 0px;">
        <i class="fa fa-bars sidebar-toggle" data-toggle="push-menu" role="button" style="float: left; padding-top: 10px; font-size: 30px; font-weight:100;"></i>
        <img src="../static/img/logo-small.png" style="height: 50px; float: left;" alt="Printer Counters" />
        <label style="font-size: 16px; float: right; padding-right: 5px;">V. {{$root.version}}</label>
        <span class="label label-danger" @click="$root.confirmRefresh()" v-if="$root.hasNewVersion">1</span>
      </a>
    </header>
  </div>
</template>
<script>
  export default {
    name: 'va-navibar-mobile',
    data () {
      return {
        remainTasksCount: 1
      }
    },
    created () {
      console.log('navibar created')
    },
    mounted () {
      console.log('navibar mounted')
    },
    updated () {
      console.log('navibar updated')
    },
    ready () {
      console.log('navibar ready')
    },
    computed: {
      activeMenu () {
        return this.$route.name
      }
    },
    watch: {
      activeMenu (val) {
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// NaviMobile.vue?4843c6c2